import React, { useState, PureComponent } from "react";
import { Link, useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import Back from "../assets/images/arrow2.png";
import User4 from "../assets/images/user4.jpg";
import { Button } from "react-bootstrap";
import camera2 from "../assets/images/camera2.png";
import { toast } from "react-toastify";
import S3FileUpload from "react-s3/lib/ReactS3";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getProductDetails, getProductEdit, subCategoryList } from "../redux/actions/productAction";
import _ from "lodash";
import { s3Config } from "../config/s3bucket";
import { compressImage } from "../utils";
const initialState = {
    RequestModalshow: false,
    store: "",
    product_name: "",
    sub_category: "",
    description: "",
    image: "",
    _id: "",
    addOns: [{ name: "", charges: "" }],
    choices: [{ name: "", charges: "" }],
    variantsData: [
        {
            flag: false,
            size: "",
            stock: "",
            price: "",
            discountedPrice: "",
            default: false,
            desc: "",
            variantId: ""
        },
    ],
    oldVariantData: [],
    newVariantsData: [],
    removeVariants: [],
    subCategoryData: [],
    errors: {},
};


const ProductEdit = () => {
    const [iState, updateState] = useState(initialState);
    const ownerData = JSON.parse(localStorage.getItem("ownerLogin"));
    // let subCategoryData = JSON.parse(localStorage.getItem("subCategoryData"));
    // console.log("subCategoryData-------", subCategoryData)
    const getId = JSON.parse(localStorage.getItem("productId"));
    // const { productList } = useSelector((state) => state.product);



   
    let ownerId = ownerData?._id
    const {
        choices,
        errors,
        _id,
        store,
        product_name,
        sub_category,
        description,
        addOns,
        newVariantsData,
        oldVariantData,
        removeVariants,
        variantsData,
        image,
    } = iState;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { subCategoryData, productData } = useSelector((state) => state.product)
  

    useEffect(() => {
        dispatch(subCategoryList())
        dispatch(getProductDetails({ productId: getId }))
    }, [])
    useEffect(() => {
        if (!_.isEmpty(productData)) {
            const updateData = _.cloneDeep(iState);
            updateData.product_name = productData?.data?.product_name;
            updateData.product_number = productData?.data?.product_number;
            updateData.addOns = productData?.data?.addOns;
            updateData.choices = productData?.data?.choices;
            updateData.variantsData = productData?.data?.productVariants;
            updateData.image = productData?.data?.image;
            updateData.description = productData?.data?.description;
            updateData.closeTime = productData?.data?.closeTime;
            updateData.sub_category = productData?.data?.subCategoryInfo?._id;
            updateState(updateData);
        }
    }, [productData]);
    const handleValidation = () => {
        let error = {};
        let formIsValid = true;
        if (!image) {
            error.imageError = "Image Can't be Empty";
            formIsValid = false;
        }
        if (!product_name) {
            error.product_nameError = "Product Name Can't be Empty";
            formIsValid = false;
        }
        if (!description) {
            error.descriptionError = "Description Can't be Empty";
            formIsValid = false;
        }
        if (variantsData.some(x => x.price == '')) {
            error.varaintsDatas_Price = "*   Price Can't be empty";
            formIsValid = false;
        }
        if (variantsData.some((x) => x.price < 0)) {
            error.varaintsDatas_Price = " * Price Can't Be Negataive ";
            formIsValid = false;
        }
        if (variantsData.some((x) => x.discountedPrice < 0)) {
            error.varaintsDatas_discountedPrice =
                " * Discounted Price Can't Be Negative";
            formIsValid = false;
        }



        if (variantsData.some(x => x.desc == '')) {
            error.varaintsDatas_Desc = "*   Description Can't be empty";
            formIsValid = false;
        }
        // if (isNaN(variantsData.some)) {
        //     error.varaintsDatas_discountedPrice = "*Only digits  are  allowed";
        //     error.formIsValid = false;
        // }

        if (variantsData.some(x => x.stock == '')) {
            error.varaintsDatas_Stock = "*   Stock Can't be empty";
            formIsValid = false;
        }
        if (variantsData.some((x) => x.stock < 0)) {
            error.varaintsDatas_Stock = " * Stocks Can't Be Negative";
            formIsValid = false;
        }

        if (variantsData.some(x => x.size == '')) {
            error.varaintsDatas_Size = "*   Size Can't be empty";
            formIsValid = false;
        }
        if (variantsData.every((x) => x.default === false)) {
            error.varaintsDatas_Default = "* Please Select Default Value";
            formIsValid = false;
        }
        if (variantsData.filter((x) => x.default)?.length === 2) {
            error.varaintsDatas_Default = "* Please Select Only One Value";
            formIsValid = false;
        }
        if (
            !addOns.some((x) => x.charges == "") &&
            addOns.some((x) => x.name == "")
        ) {
            error.addOnsError = "* Please Fill Add Ons Both The Fields";
            formIsValid = false;
        }
        if (
            addOns.some((x) => x.charges == "") &&
            !addOns.some((x) => x.name == "")
        ) {
            error.addOnsError = "* Please Fill Add Ons Both The Fields";
            formIsValid = false;
        }

        if (
            !choices.some((x) => x.charges == "") &&
            choices.some((x) => x.name == "")
        ) {
            error.choicesError = "* Please Fill Choices Both The Fields";
            formIsValid = false;
        }
        if (
            choices.some((x) => x.charges == "") &&
            !choices.some((x) => x.name == "")
        ) {
            error.choicesError = "* Please Fill Choices Both The Fields";
            formIsValid = false;
        }


        if (addOns.some((x) => x.charges < 0)) {
            error.addOns_chargesError = " * Add Ons Charges Can't Be Negative";
            formIsValid = false;
        }
        if (choices.some((x) => x.charges < 0)) {
            error.Choices_chargesError = " * Choices Charges Can't Be Negative";
            formIsValid = false;
        }


        updateState({ ...iState, errors: error });
        return formIsValid;
    };

    const handleInputValue = (e) => {
        const { name, value } = e.target;
        updateState({ ...iState, [name]: value });
    };

    const handleOnsChange = (e, i) => {
        const { name, value } = e.target;
        let addOnesData = [...addOns];
        addOnesData[i] = { ...addOns[i], [name]: value };
        updateState({
            ...iState,
            addOns: addOnesData,
        });
    };

    const handleVariantsChange = (e, i) => {
        const { name, value } = e.target;
        let variantChangeData = [...variantsData];
        variantChangeData[i] = { ...variantsData[i], [name]: value };
        updateState({ ...iState, variantsData: variantChangeData });
    };

    const checkBoxHandler = (e, index) => {
       
        const { name, value } = e.target;
        let tempData = variantsData;
      
        if (tempData.length == 1) {
            let temp1 = variantsData;
            let temp2 = variantsData?.[index];
            temp2["default"] = true;
            for (let i = 0; i < temp1?.length; i++) {
                if (temp1[i] == index) {
                    temp1.splice(index, 1, temp2)
                }
            }

            updateState({ ...iState, variantsData: temp1 });
        }
        if (tempData.length > 1) {
            let temp1 = variantsData;

            temp1.forEach((item, i) => {
                if (index == i) {
                    item.default = e.target.checked
                }
            });
          

            updateState({ ...iState, variantsData: temp1 });

        }

    }

    const handleChoicesChange = (e, i) => {
        const { name, value } = e.target;
        let choicesChangeData = [...choices];
        choicesChangeData[i] = { ...choices[i], [name]: value };
        updateState({ ...iState, choices: choicesChangeData });
    };



   const onFileHandler = async (e) => {
   const file = e?.target?.files[0];
 
   if (!file) return;
 
   // ✅ validation
   const validTypes = ["image/jpeg", "image/jpg", "image/png"];
 
   if (!validTypes.includes(file.type)) {
     toast.error("Only jpeg, jpg and png are allowed", {
       position: toast.POSITION.TOP_RIGHT,
     });
     return;
   }
 
   try {
     // 🔥 compress image
     const compressedFile = await compressImage(file, 0.7, 1024); 
     // 🔥 upload to S3
     const data = await S3FileUpload.uploadFile(compressedFile, s3Config);
 
     // ✅ update state
     updateState((prev) => ({
       ...prev,
       image: data.location,
     }));
 
   } catch (error) {
     console.error("Upload Error:", error);
 
     toast.error("Image upload failed", {
       position: toast.POSITION.TOP_RIGHT,
     });
   }
 };
    const addOnesClick = () => {
        updateState({
            ...iState,
            addOns: [...iState.addOns, { name: "", charges: "" }],
        });
    };

    const removeOnesClick = (i) => {
        let user = [...addOns];
        user.splice(i, 1);
        updateState({
            ...iState,
            addOns: user,
        });
    };

    const addVariantsClick = () => {
        updateState({
            ...iState,
            variantsData: [
                ...iState.variantsData,
                {
                    flag: true,
                    size: "",
                    desc: "",
                    stock: "",
                    price: "",
                    discountedPrice: "",
                    default: false,
                    variantId: "",
                },
            ],
        });
    };

    const removeVariantsClick = (i, variantID) => {
        // console.log("got iddd------------->",variantID)
        let tempRemoveID = removeVariants;
        tempRemoveID.push(variantID);
        // console.log("tempRemoveID",tempRemoveID)
        // console.log("removeVariants-->",tempRemoveID)
        let varaintsDatas = [...variantsData];
        varaintsDatas.splice(i, 1);
        updateState({
            ...iState,
            variantsData: varaintsDatas,
            removeVariants: tempRemoveID
        });
    };

    const addChoicesClick = () => {
        updateState({
            ...iState,
            choices: [...iState.choices, { name: "", charges: "" }],
        });
    };

    const removeChoicesClick = (i) => {
        let removeChoicesData = [...choices];
        removeChoicesData.splice(i, 1);
        updateState({ ...iState, choices: removeChoicesData });
    };




    const editProductsFun = () => {
        const formIsValid = handleValidation();
        if (formIsValid) {

            let data = {

                productId: getId,
                image,
                product_name,
                sub_category,
                description,
                addOns,
                variantsData: oldVariantData,
                newVariantsData: newVariantsData,
                removeVariants: removeVariants,
                choices,

            };
          
            dispatch(getProductEdit(data))
                .then((res) => {
                 
                    if (res.status === 200) {
                        navigate("/product-management")
                        toast.success(res.message, {
                            position: toast.POSITION.TOP_RIGHT,
                        });
                        localStorage.removeItem("storeId")

                    }
                })
                .catch((err) => {
                    toast.error(err.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                });
        }
    };


    useEffect(() => {
        filterData();
        findVariant();
    }, [variantsData, addOns]);
    const filterData = () => {
        let temp = variantsData;
        temp.forEach((item, index) => {
          
            temp[index] = {
                default: item?.default,
                price: item?.price,
                discountedPrice: item?.discountedPrice,
                stock: item?.stock,
                desc: item?.desc,
                size: item?.size,
                variantId: item?._id || item?.variantId,
                flag: item?.flag
            };
        });
        updateState({ ...iState, variantsData: temp });
    };


    // console.log("anuradah--->", variantsData, addOns, description, product_name, choices)

    const findVariant = () => {
        let temp = variantsData;
        const newVariantData = temp.filter((item, index) => item?.flag);
        const variantData = temp.filter((item, index) => !(item?.flag));
        updateState({ ...iState, oldVariantData: variantData, newVariantsData: newVariantData })
        // console.log("variantsData", variantsData);
        // console.log("newVariantData", newVariantData);
        // console.log("oldVariantData", oldVariantData);

    }
    // console.log("ValueCte......",subCategoryData)

    return (
        <div>
            <Header />
            <SideNav />
            <div class="WrapperArea">
                <div class="WrapperBox">
                    <div class="TitleBox">
                        <div>
                            <h4 class="Title"><Link to="/product-management" > <img src={Back} /></Link>Edit  Product</h4>
                        </div>
                    </div>
                    <div class="Small-Wrapper">
                        <div class="CommonForms">
                            <div className="form-group">
                                <div class="UploadImages">
                                    {image ? (
                                        <>
                                            <img src={image} />
                                        </>
                                    ) : (
                                        <>

                                            <img src={camera2} />

                                            <h6>Add Product images</h6>
                                            {/* <p> Image formats : jpg, png / 5MB Max.</p> */}
                                        </>
                                    )}

                                    <input
                                        type="file"
                                        name="image"
                                        // value={image}
                                        onChange={onFileHandler}
                                    />
                                </div>
                                <span style={{ color: "red", fontSize: "14px" }}>
                                    {errors.imageError}
                                </span>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Product Name</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter Product Name"
                                            name="product_name"
                                            value={product_name}
                                            onChange={handleInputValue}
                                        />

                                    </div>
                                    <span style={{ color: "red", fontSize: "14px" }}>
                                        {errors.product_nameError}
                                    </span>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Select Sub-Category</label>
                                        <select
                                            className="form-control"
                                            name="sub_category"
                                            value={sub_category}
                                            onChange={handleInputValue} 
                                            // disabled
                                        >
                                            <option value="">Select</option>
                                            {subCategoryData.data &&
                                                subCategoryData?.data?.map((ele) => (
                                                    // console.log("valueCategory",ele);
                                                    <option value={ele?._id}>
                                                        {" "}
                                                        {ele?.sub_category_name}
                                                    </option>
                                                ))};
                                        </select>
                                    </div>
                                </div>


                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Description</label>
                                        <textarea
                                            className="form-control"
                                            rows="5"
                                            name="description"
                                            value={description}
                                            onChange={handleInputValue}
                                        >
                                            Description....
                                        </textarea>
                                        <span style={{ color: "red", fontSize: "14px" }}>
                                            {errors.descriptionError}
                                        </span>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Add Sizes</label>
                                        {variantsData?.length > 0 &&
                                            variantsData?.map((ele, index) => (
                                                <>
                                                    <div className="DosageBox">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Size Specification</label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        name="size"
                                                                        value={ele?.size}
                                                                        onChange={(e) =>
                                                                            handleVariantsChange(e, index)
                                                                        }
                                                                    />
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.varaintsDatas_Size}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {/* <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Select Stock Value</label>
                                                                    <select
                                                                        name="stock"
                                                                        value={ele?.stock}
                                                                        className="form-control"
                                                                        onChange={(e) =>
                                                                            handleVariantsChange(e, index)
                                                                        }
                                                                    >
                                                                        <option value="">Select </option>
                                                                        <option value="3">3 </option>
                                                                        <option value="6">6 </option>
                                                                    </select>
                                                                </div>
                                                            </div> */}
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Enter Stock Value</label>
                                                                    <input type="number"
                                                                        name="stock"
                                                                        value={ele?.stock}
                                                                        className="form-control"
                                                                        onChange={(e) =>
                                                                            handleVariantsChange(e, index)
                                                                        }
                                                                    />
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.varaintsDatas_Stock}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label> Price</label>
                                                                    <input
                                                                        type="number"
                                                                        class="form-control"
                                                                        name="price"
                                                                        value={ele?.price}
                                                                        onChange={(e) =>
                                                                            handleVariantsChange(e, index)
                                                                        }
                                                                    />
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.varaintsDatas_Price}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Discounted Price</label>
                                                                    <input
                                                                        type="number"
                                                                        class="form-control"
                                                                        name="discountedPrice"
                                                                        value={ele?.discountedPrice}
                                                                        onChange={(e) =>
                                                                            handleVariantsChange(e, index)
                                                                        }
                                                                    />
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.varaintsDatas_discountedPrice}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-12">
                                                                <div class="form-group">
                                                                    <label>Description</label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        rows="3"
                                                                        name="desc"
                                                                        value={ele?.desc}
                                                                        onChange={(e) =>
                                                                            handleVariantsChange(e, index)
                                                                        }
                                                                    >
                                                                        Description....
                                                                    </textarea>
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.varaintsDatas_Desc}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div className="form-group">
                                                                    <label class="Checkbox">
                                                                        Mark as Default Price
                                                                        <input
                                                                            type="checkbox"
                                                                            name="default"
                                                                            checked={ele?.default}
                                                                            onChange={(e) =>
                                                                                checkBoxHandler(e, index)
                                                                            }
                                                                      
                                                                        />

                                                                        <span class="checkmark"></span>
                                                                    </label>
                                                                    <span
                                                                        style={{ color: "red", fontSize: "14px" }}
                                                                    >
                                                                        {errors.varaintsDatas_Default}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {variantsData.length > 1 && (
                                                        <p className="text-right">
                                                            <Link
                                                                onClick={() => {
                                                                    // console.log("variantsData inside--->",var )
                                                                    removeVariantsClick(index, ele.variantId)
                                                                }
                                                                }
                                                                to=""
                                                                className="CommonAdd"
                                                            >
                                                                {" "}
                                                                - Remove
                                                            </Link>
                                                        </p>
                                                    )}

                                                </>
                                            ))}

                                        <p className="text-right">
                                            <Link
                                                to=""
                                                onClick={addVariantsClick}
                                                className="CommonAdd"
                                            >
                                                {" "}
                                                + Add More
                                            </Link>
                                        </p>
                                    </div>

                                </div>

                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Add Ons</label>
                                        {addOns && addOns.length > 0 &&
                                            addOns.map((ele, index) => (
                                                // console.log(ele)
                                                <>
                                                    <div className="DosageBox">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Add-On Name</label>
                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        name="name"
                                                                        value={ele?.name}
                                                                        onChange={(e) => handleOnsChange(e, index)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Extra Charges</label>
                                                                    <input
                                                                        type="number"
                                                                        class="form-control"
                                                                        name="charges"
                                                                        value={ele?.charges}
                                                                        onChange={(e) => handleOnsChange(e, index)}
                                                                    />
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.addOns_chargesError}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {addOns.length > 1 && (
                                                        <p className="text-right">
                                                            <Link
                                                                onClick={() => removeOnesClick(index)}
                                                                to=""
                                                                className="CommonAdd"
                                                            >
                                                                {" "}
                                                                - Remove
                                                            </Link>
                                                        </p>
                                                    )}
                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                        {errors.addOnsError}
                                                    </span>
                                                </>
                                            ))}

                                        <p className="text-right">
                                            <Link onClick={addOnesClick} to="" className="CommonAdd">
                                                {" "}
                                                + Add More
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Add More choice</label>
                                        {choices && choices.length > 0 &&
                                            choices.map((ele, i) => (
                                                <>
                                                    <div className="DosageBox">
                                                        <div className="row">
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Choice Name</label>

                                                                    <input
                                                                        type="text"
                                                                        class="form-control"
                                                                        name="name"
                                                                        value={ele?.name}
                                                                        onChange={(e) => handleChoicesChange(e, i)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="col-sm-6">
                                                                <div class="form-group">
                                                                    <label>Extra Charges</label>
                                                                    <input
                                                                        type="number"
                                                                        class="form-control"
                                                                        name="charges"
                                                                        value={ele?.charges}
                                                                        onChange={(e) => handleChoicesChange(e, i)}
                                                                    />
                                                                    <span style={{ color: "red", fontSize: "14px" }}>
                                                                        {errors.Choices_chargesError}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {choices.length > 1 && (
                                                        <p className="text-right">
                                                            <Link
                                                                onClick={(e) => removeChoicesClick(i)}
                                                                to=""
                                                                className="CommonAdd"
                                                            >
                                                                {" "}
                                                                - Remove
                                                            </Link>
                                                        </p>
                                                    )}
                                                </>

                                            ))}
                                        <span style={{ color: "red", fontSize: "14px" }}>
                                            {errors.choicesError}
                                        </span>

                                        <p className="text-right">
                                            <Link
                                                onClick={(e) => addChoicesClick()}
                                                to=""
                                                className="CommonAdd"
                                            >
                                                {" "}
                                                + Add More
                                            </Link>
                                        </p>
                                    </div>
                                </div>

                            </div>
                            <div class="ButtonMain ">
                                <button onClick={editProductsFun} class="Button AddButton">Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );
}
export default ProductEdit